module.exports = __webpack_public_path__ + "static/media/JP_RS_EYELASHES04.46e169ab.jpg";